import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noNewFriend.png'


const _withScopeId = n => (_pushScopeId("data-v-2478cd2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { action: "/" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "avatar" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "userInfo" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = {
  key: 0,
  class: "online"
}
const _hoisted_11 = {
  key: 1,
  class: "noline"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "nodata"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_20 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", _hoisted_1, [
      _createVNode(_component_van_search, {
        shape: "round",
        modelValue: $setup.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.value) = $event)),
        "show-action": "",
        "action-text": $setup.t('tips.search'),
        placeholder: $setup.t('im.inputPlaceholder'),
        onSearch: $setup.onSearch,
        onCancel: $setup.onCancel
      }, null, 8 /* PROPS */, ["modelValue", "action-text", "placeholder"])
    ]),
    ($setup.friendList.length > 0 || $setup.groupList.length > 0 || $setup.mList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.friendList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('im.contact')), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.friendList, (item_data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "userBox",
                    onClick: ($event: any) => ($setup.toChat(item_data))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_van_image, {
                        round: "",
                        width: "40",
                        fit: "cover",
                        height: "40",
                        src: item_data.headurl
                      }, null, 8 /* PROPS */, ["src"]),
                      _withDirectives(_createElementVNode("img", {
                        src: $setup.zbtype,
                        alt: ""
                      }, null, 8 /* PROPS */, _hoisted_7), [
                        [_vShow, item_data.type == 1]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(item_data.nickname), 1 /* TEXT */),
                      (item_data.lastlogouttime == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('im.nowonline')), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.IMformatDate(item_data.lastlogouttime)) + _toDisplayString(_ctx.$t('im.online')), 1 /* TEXT */))
                    ])
                  ], 8 /* PROPS */, _hoisted_5))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.groupList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('im.group')), 1 /* TEXT */),
                ($setup.groupList.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.groupList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "messageItem",
                        onClick: ($event: any) => ($setup.toChat(item))
                      }, [
                        _createVNode($setup["MessageItem"], { data: item }, null, 8 /* PROPS */, ["data"])
                      ], 8 /* PROPS */, _hoisted_14))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.mList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('tips.chatcontent')), 1 /* TEXT */),
                ($setup.mList.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.mList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "messageItem",
                        onClick: ($event: any) => ($setup.toChat(item))
                      }, [
                        _createVNode($setup["MessageItem"], { data: item }, null, 8 /* PROPS */, ["data"])
                      ], 8 /* PROPS */, _hoisted_17))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('noData.noSearch')), 1 /* TEXT */),
          _createCommentVNode(" <div class=\"subtitle\">去看看别的吧，精彩正在直播中</div> ")
        ]))
  ]))
}